import { DocumentIndex } from '@/interfaces/documentIndex';
import { DocumentIndexResource, documentIndexResource } from '@/resources/documentIndex.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł dokumentów z indeksu
 *
 * @export
 * @class DocumentIndexModule
 * @extends {EntityModule<DocumentIndex, DocumentIndexResource>}
 */
export class DocumentIndexModule extends EntityModule<DocumentIndex, DocumentIndexResource> {
  constructor() {
    super(documentIndexResource);
    this.state = {
      ...this.state,
      statistics: [],
      financialReport: []
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje statystyki
       *
       * @param {*} localState
       * @param {*} statistics
       */
      saveStatistics(localState: any, statistics: any): void {
        localState.statistics = statistics;
      },

      /**
       * Zapisuje raport finansowy
       *
       * @param {*} localState
       * @param {*} report
       */
      saveFinancialReport(localState: any, report: any): void {
        localState.financialReport = report;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Pobiera statystyki
       *
       * @param {*} options
       * @returns {Promise<*>}
       */
      getStatistics: (context: any, options: any): Promise<any> =>
        this.resource.statistics(options).then(statistics => {
          context.commit('saveStatistics', statistics);
          return statistics;
        }),

      /**
       * Pobiera raport finansowy
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<any>}
       */
      getFinancialReport: (context: any, variables: any): Promise<any> =>
        this.resource.financialReport(variables).then(report => {
          context.commit('saveFinancialReport', report);
          return report;
        })
    };
  }
}

export default new DocumentIndexModule();
